'use client';

import { useEffect } from 'react';
import { useScrollPreservation } from '../hooks/use-scroll-preservation';

interface CityPageWrapperProps {
  children: React.ReactNode;
  citySlug: string;
}

export default function CityPageWrapper({
  children,
  citySlug,
}: CityPageWrapperProps) {
  const { restoreScrollPosition } = useScrollPreservation(citySlug);

  useEffect(() => {
    // Restore scroll position when component mounts
    const timeoutId = setTimeout(() => {
      restoreScrollPosition();
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [restoreScrollPosition]);

  return <>{children}</>;
}
